import { render, staticRenderFns } from "./ClassFormModal.vue?vue&type=template&id=4c0f1708&scoped=true&"
import script from "./ClassFormModal.vue?vue&type=script&lang=js&"
export * from "./ClassFormModal.vue?vue&type=script&lang=js&"
import style0 from "./ClassFormModal.vue?vue&type=style&index=0&id=4c0f1708&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f1708",
  null
  
)

export default component.exports